import React from 'react';
import EyeIcon from '@mui/icons-material/Visibility';
import { observer } from "mobx-react";



const Eye = observer( (props)=> {
  return (
    <EyeIcon {...props} />
  );
})

export { Eye };